module.exports = __webpack_public_path__ + "img/30.343c015.jpg";